import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = '優爾商城';

/**
 * SEO 元件 - 僅負責 SPA 內部導航時更新瀏覽器頁籤 title 與 description。
 *
 * canonical / og:* / twitter:* / line:* / Product JSON-LD 全部由
 * server/middleware/seoMiddleware.js 在 server-side 動態渲染，
 * 避免 client-side Helmet 與 server-rendered HTML 重複造成多重 canonical。
 *
 * 對外 API 維持原樣（title/description/keywords/url/image/type/product/noindex），
 * 但只實際渲染瀏覽器需要的 title 與 description。
 */
const SEO = ({ title, description, keywords, noindex = false }) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
};

export default SEO;
